import { DealsComponent } from "@/components/deals";

export default function Deals() {
  return <DealsComponent />;
}
